<template>
  <div style="margin-bottom: 40px;">
    <div v-if="type" class="header-logo">
      <div class="loga-style">
        <div class="text">
          O'zbekiston Respublikasi Sog'liqni saqlash vazirligi
          "OQTOSH" 
          klinikasi
        </div>
        <div class="text-izoh">
          O'z RSSV ning 2020 yil 31 dekabrdagi № 363-sonli buyrug'i bilan tasdiqlangan 003-raqamli tibbiy hujjat shakli
        </div>
      </div>
    </div>
    <div v-else>
      <div style="display: flex; justify-content: space-between;">
        <img
          style="width: 270px; height: 150px;"
          src="../../../assets/img/logo_tibiyot.png"
          alt=""
        />
        <div style="display: flex; align-items: center;">
          <div style="width: 460px; font-size: 14pt; font-weight: 500;">
            <div style="display: flex; align-items: center; gap: 10px;">
              <img style="width: 50px; color: #ca0202;" src="../../../../public/location.png" alt="location">
              <span>Farg’ona viloyati, Oltiariq tumani  <br> Fayzobod qishlog’i 32 – maktab yonida <br></span>
            </div>
            <div style="display: flex; align-items: center; gap: 10px;">
              <img style="width: 50px; color: #ca0202;" src="../../../../public/phone.png" alt="phone">
              <span style="font-size: 13px;"></span> <b style="font-size: 14pt;">+998 (90) 055 00 03</b>
            </div>
         </div>
        </div>
      </div>
      <div
        v-if="stat"
        class="text-izoh"
        style="font-size: 14pt; font-weight: 500;"
      >
        <!-- Andijon shaxar Qizil sharq ko‘chasi 3-uy. Tel:74-234-20-02 E-mail
        :cardio-center2018@umail.uz -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["type", "stat"]
};
</script>
<style>
.header-logo {
  padding: 7px;
  width: 100%;
}
.sunsit-izoh{
  font-size: 23px;
  /* color: red; */
  margin-top: 10px;
  color: black;
  /* line-height: 0.5px; */
  /* padding-bottom: 10px; */
  font-weight: 600;
  font-family: 'Times New Roman', Times, serif;
}
.malumotnoma {
  width: 37%;
  font-family: "Times New Roman", Times, serif;
  font-size: 16pt;
  font-weight: 600;
}
.loga-style {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  font-family: 'Times New Roman', Times, serif;
}
.text {
  font-size: 14pt;
  width: 300px;
  /* text-align: center;
  color: black;
  font-weight: 700;
  font-family: Roboto; */
}
.text-izoh {
  /* border-top: 4px double #000;
  border-bottom: 4px double #000; */
  width: 400px;
  font-size: 16pt;
  text-align: center;
  /* color: black;
  padding-bottom: 10px;
  font-weight: 600; */
}
</style>
